"use client"

import React from 'react';
import { InboxOutlined } from '@ant-design/icons';
import Dragger from 'antd/lib/upload/Dragger';
import useMessage from 'antd/es/message/useMessage';
import styles from './index.module.css';

interface ImageUploadProps {
  onChange: (file: File) => void;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ onChange }) => {
  const [messageApi, contextHolder] = useMessage();

  const beforeUpload = (file: File) => {
    const isRightType = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isRightType) {
      messageApi.error('You can only upload JPG/PNG file!');
      return false;
    }
    if (file.size > 25 * 1024 * 1024) {
      messageApi.error('This image is too large. Try uploading one under 25 MB.');
      return false;
    }

    onChange(file);
    return false;
  };

  return (
    <div className={styles['upload-wrap']}>
      {contextHolder}
      <Dragger
        beforeUpload={beforeUpload}
        name='file'
        accept='.jpg, .jpeg, .png'
        showUploadList={false}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className={styles['ant-upload-text']}>Click or drag file to this area to upload</p>
      </Dragger>
    </div>
  );
}

export default ImageUpload;
